import {
    companyLegalTypeList,
    validateEmail,
    validatePhoneNumber,
    validateWebSite
  } from 'utils';

export const formFields2_1 = [
  
    {
      id: 'companyName',
      label: 'Επωνυμία Προμηθευτή',
      type: 'text',
      name: 'companyName',
      size: 'large',
      placeholder: 'Εισάγετε Επωνυμία Προμηθευτή',
      span: 24,
      rules: [{ required: true, message: 'Το πεδίο είναι υποχρεωτικό' }],
      disabled: true,
      asterisk: true,
    },
    {
      id:'abiVat',
      label: 'Α.Φ.Μ.',
      type: 'text',
      name: 'abiVat',
      size: 'large',
      placeholder: 'Εισάγετε Α.Φ.Μ.',
      span: 24,
      asterisk: true,
      rules: [
        { required: true, message: 'Το πεδίο είναι υποχρεωτικό' },
        /*() => ({
          validator(_, value) {
            return validateAFM(value);
          },
        }),*/
      ],
      disabled: true,
    },
  //   {
  //     id: 'regDate',
  //     label: 'Ημ. Σύστασης',
  //     type: 'text',
  //     name: 'regDate',
  //     size: 'large',
  //     placeholder: 'Εισάγετε Ημ. Σύστασης',
  //     span: 12,
  //     rules: [
  //       { required: true, message: 'Το πεδίο είναι υποχρεωτικό' },
  //       { max: 50 , message: 'Το πεδίο μπορεί να έχει το πολύ 50 χαρακτήρες' },
  //     ],
  //     asterisk: true,
  //     disabled: true,
  // },
    {
      id: 'mainKAD',
      label: 'ΚΑΔ Κύριας Δραστηριότητας',
      type: 'text',
      name: 'mainKAD',
      size: 'large',
      placeholder: 'Εισάγετε ΚΑΔ Κύριας Δραστηριότητας',
      span: 24,
      rules: [{ required: true, message: 'Το πεδίο είναι υποχρεωτικό' }],
      disabled: true,
      asterisk: true,
    },
    {
      id: 'additionalKAD',
      label: 'Συμπληρωματικοί ΚΑΔ',
      type: 'text',
      name: 'additionalKAD',
      size: 'large',
      placeholder: 'Εισάγετε Συμπληρωματικό ΚΑΔ',
      span: 24,
      rules: [{ required: true, message: 'Το πεδίο είναι υποχρεωτικό' }],
      disabled: true,
      // asterisk: true,
    },
    {
      id: 'companyLegalType',
      label: 'Νομική Μορφή',
      title: 'Νομική Μορφή',
      type: 'select',
      name: 'companyLegalType',
      size: 'medium',
      options: companyLegalTypeList,
      placeholder: 'Επιλέξτε Νομική Μορφή',
      span: 24,
      asterisk: true,
      rules: [{ required: true, message: 'Το πεδίο είναι υποχρεωτικό' }],
    },
  ];

  export const formFields2_2 = [
    {
      id: 'abiStreetFull',
      label: 'Οδός - Αριθμός',
      type: 'text',
      name: 'abiStreetFull',
      size: 'large',
      placeholder: 'Εισάγετε Οδό - Αριθμό',
      span: 12,
      asterisk: true,
      rules: [{ required: true, message: 'Το πεδίο είναι υποχρεωτικό' }],
      disabled: true,
    },
    {
      id: 'abiTk',
      label: 'Τ.Κ.',
      type: 'text',
      name: 'abiTk',
      size: 'large',
      placeholder: 'Εισάγετε Τ.Κ.',
      span: 12,
      asterisk: true,
      rules: [{ required: true, message: 'Το πεδίο είναι υποχρεωτικό' }],
    },
    { 
      id: 'abiPerfecture',
      label: 'Νομός',
      title: 'Νομός',
      type: 'select',
      name: 'abiPerfecture',
      size: 'small',
      placeholder: 'Επιλέξτε Νομό',
      span: 12,
      asterisk: true,
      rules: [{ required: true, message: 'Το πεδίο είναι υποχρεωτικό' }],
      //disabled: true,
    },
    {
      id: 'abiDistrict',
      label: 'Περιοχή',
      title: 'Περιοχή',
      type: 'select',
      name: 'abiDistrict',
      size: 'small',
      placeholder: 'Επιλέξτε Περιοχή',
      span: 12,
      asterisk: true,
      rules: [{ required: true, message: 'Το πεδίο είναι υποχρεωτικό' }],
      //disabled: true,
    },
    {
      id: 'invMob',
      label: 'Τηλέφωνο',
      type: 'text',
      name: 'invMob',
      size: 'large',
      maxLength: 10,
      placeholder: 'Εισάγετε Τηλέφωνο',
      span: 24,
      asterisk: true,
      rules: [
        () => ({
          validator(_, value) {
            return validatePhoneNumber(value, false);
          },
        }),
      ],
    },
    {
      id: 'website',
      label: 'Ιστοχώρος',
      type: 'text',
      name: 'website',
      size: 'large',
      placeholder: 'Εισάγετε Ιστοχώρο',
      span: 24,
      maxLength: 80,
      validateTrigger: 'onBlur',
      trigger: 'onBlur', 
      rules: [
        {
          validator: (_, value) => validateWebSite(value)
        }
      ],
    },
    // {
    //   id: 'website',
    //   label: 'Ιστοχώρος',
    //   // prefix: 'http://',
    //   type: 'text',
    //   name: 'website',
    //   size: 'large',
    //   placeholder: 'Εισάγετε Ιστοχώρο',
    //   span: 24,
    //   maxLength: 80,
    //   rules: [
    //     { 
    //       type: 'url', 
    //       message: 'Παρακαλώ εισάγετε έγκυρο URL ιστοσελίδας' 
    //     }
    //   ],
    // },
    {
      id: 'invMail',
      label: 'E-mail',
      type: 'text',
      name: 'invMail',
      size: 'large',
      placeholder: 'Εισάγετε E-mail',
      maxLength:50,
      span: 24,
      asterisk: true,
      rules: [
        { required: true, message: 'Το πεδίο είναι υποχρεωτικό' },
        {
          validator: (_, value) => validateEmail(value)
        }
      ],
    },
  ];

